import React from "react";

function BS4_Carousel() {
  return (
    <div>
      <h1>BS4_Carousel Component</h1>
      <p>This is the BS4_Carousel tutorial page content.</p>
    </div>
  );
}

export default BS4_Carousel;
